import React from 'react';
import NotAvailable from '../Common/NotAvailable';

interface ProviderRatingProps {
  avgRating?: number | null;
  reviewCount?: number;
}

// Average rating from approved reviews clients left on CLOUT; none until the first is approved
const ProviderRating: React.FC<ProviderRatingProps> = ({ avgRating, reviewCount = 0 }) => {
  if (avgRating == null) return <NotAvailable />;

  return (
    <span>
      {avgRating.toFixed(1)} ({reviewCount} {reviewCount === 1 ? 'review' : 'reviews'})
    </span>
  );
};

export default ProviderRating;
